class Folder {
    id: number;
    schoolID: number;
    parentID: number;
    name: string;
    
    childFolderCount: number;
    childSOFCount: number;
    childTDFCount: number;
    childDOFCount: number;

    published: boolean;
    archive: boolean;
    recycled: boolean;

    createdBy: number;
    createdOn: Date;
    editedBy: number;
    editedOn: Date;
    recycledBy: number;
    recycledOn: Date;

    constructor(data: Partial<Folder>) {
        Object.assign(this, data);

        if (typeof this.createdOn === "string")
            this.createdOn = new Date(this.createdOn);
        if (typeof this.editedOn === "string")
            this.editedOn = new Date(this.editedOn);
        if (typeof this.recycledOn === "string")
            this.recycledOn = new Date(this.recycledOn);
    }
}

export default Folder;